import { useMutation, useQueryClient } from "@tanstack/react-query";
import { FORM30_ENDPOINTS } from "../../services/network/endpoints";
import { toast } from "react-toastify";
import { saveForm30 } from "../../services/network/form30-api";

interface SaveForm30Params {
    sector_id: string;
    year: number;
    data: Record<string, Record<string, Record<string, number | null>>>;
}

export function useSaveForm30() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [FORM30_ENDPOINTS.SAVE],
        mutationFn: ({ sector_id, year, data }: SaveForm30Params) => 
            saveForm30(sector_id, year, data),
        onError() {
            toast.error("Ошибка сохранения формы 30");
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({
                queryKey: [
                    FORM30_ENDPOINTS.FETCH,
                    variables.sector_id,
                    variables.year
                ]
            });
            toast.success("Форма 30 успешно сохранена");
        }
    });
}
